import { useState, useEffect } from 'react';

import { Label } from 'src/components/label';
import { overtimeApi } from 'src/api/overtime.api';

const REFRESH_MS = 60_000;

/**
 * Pending-overtime counter for the nav item. Fetches its own count (mount +
 * every 60s). All errors are swallowed — the badge must never break the nav
 * (e.g. when the backend endpoint isn't deployed yet → 404).
 */
export function OvertimePendingBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const fetchCount = async () => {
      try {
        const pending = await overtimeApi.getPendingCount();
        if (!cancelled) setCount(pending);
      } catch {
        // silent — nav must keep working without the badge
      }
    };

    fetchCount();
    const handle = setInterval(fetchCount, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(handle);
    };
  }, []);

  if (count <= 0) return null;

  return <Label color="error">{count}</Label>;
}
